import React from 'react';

export const ListItem: React.FC = (props) => <li {...props} className="pb-2" />;
